const formatName = (name: string, entityId: string | null): string =>
  entityId ? `${name} - ${entityId}` : name;

export default formatName;
